var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.75 6H4.58333H19.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4163 6V20C17.4163 20.5304 17.2232 21.0391 16.8794 21.4142C16.5356 21.7893 16.0692 22 15.583 22H6.41634C5.93011 22 5.4638 21.7893 5.11998 21.4142C4.77616 21.0391 4.58301 20.5304 4.58301 20V6M7.33301 6V4C7.33301 3.46957 7.52616 2.96086 7.86998 2.58579C8.2138 2.21071 8.68011 2 9.16634 2H12.833C13.3192 2 13.7856 2.21071 14.1294 2.58579C14.4732 2.96086 14.6663 3.46957 14.6663 4V6",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.16699 11V17",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.833 11V17",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.69da55ebfae33ae3be70e3556cb80f0a.svg";
export { ForwardRef as ReactComponent };